var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wp-items-edit',{attrs:{"content-type":"research-articles","content-type-singular":"research-article","content-name":"Research articles","content-name-singular":"Research article"}})}
var staticRenderFns = []

export { render, staticRenderFns }